import React from "react";
import "./Legal.css";
import SEO from "../../Components/SEO";

function PrivacyPolicy() {
  return (
    <>
      <SEO
        title="Privacy Policy"
        description="Read the Lutology Privacy Policy – how we collect, use and protect your information."
      />

      <main
        className="legal-page"
        role="main"
        aria-label="Lutology Privacy Policy"
      >
        <h1>Privacy Policy</h1>
        <p className="legal-meta">Last updated: 2025</p>

        <p>
          At Lutology™ (“we”, “us”, “our”), we respect your privacy and are
          committed to protecting your personal data. This Privacy Policy
          explains what information we collect, how we use it and what rights
          you have.
        </p>

        <h2>1. Information We Collect</h2>
        <p>We may collect the following types of information:</p>
        <ul>
          <li>
            <strong>Contact details:</strong> name, email address, shipping
            address, phone number (if provided).
          </li>
          <li>
            <strong>Order information:</strong> products purchased, order
            history, payment method (processed by third parties).
          </li>
          <li>
            <strong>Technical data:</strong> IP address, browser type, device
            information, pages viewed, time spent on the Site.
          </li>
          <li>
            <strong>Cookies:</strong> used for analytics, preferences and site
            functionality.
          </li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>We use your information to:</p>
        <ul>
          <li>Process and fulfill your orders.</li>
          <li>Provide customer support and respond to inquiries.</li>
          <li>Improve and optimize the Site and our services.</li>
          <li>
            Send you updates or offers, only where you have explicitly consented
            (you may opt out at any time).
          </li>
          <li>Comply with legal obligations.</li>
        </ul>

        <h2>3. Legal Bases for Processing</h2>
        <p>
          Depending on your location, we process personal data on the basis of:
        </p>
        <ul>
          <li>Performance of a contract.</li>
          <li>Legitimate interests.</li>
          <li>Legal obligations.</li>
          <li>Consent (where applicable).</li>
        </ul>

        <h2>4. Data Sharing</h2>
        <p>We do not sell your personal data.</p>
        <p>
          We may share information with trusted service providers, including:
        </p>
        <ul>
          <li>Payment processors (PayPal, Stripe, Etsy).</li>
          <li>Shipping and logistics partners.</li>
          <li>Analytics and email service providers.</li>
        </ul>

        <h2>5. Data Retention</h2>
        <p>
          We retain personal data for as long as necessary for the purposes
          described in this Policy or as required by law.
        </p>

        <h2>6. Cookies</h2>
        <p>
          Cookies help improve user experience and site performance. You may
          disable cookies in your browser settings, though some features may not
          function properly.
        </p>

        <h2>7. Your Rights</h2>
        <p>
          You may have the right to request access, correction, deletion or
          restriction of your personal data, depending on your jurisdiction.
        </p>
        <p>
          To exercise your rights, please{" "}
          <a href="/contact" className="legal-link">
            reach us through our Contact page
          </a>
          .
        </p>

        <h2>8. International Transfers</h2>
        <p>
          As our operations and service providers may be located globally, your
          data may be transferred internationally with appropriate safeguards.
        </p>

        <h2>9. Data Security</h2>
        <p>
          We take reasonable measures to protect your personal information, but
          no online system is completely secure.
        </p>

        <h2>10. Changes</h2>
        <p>
          We may update this Privacy Policy from time to time. Continued use of
          the Site indicates acceptance of the updated terms.
        </p>

        <h2>11. Contact</h2>
        <p>
          For any privacy-related questions, please{" "}
          <a href="/contact" className="legal-link">
            reach out via our Contact page
          </a>
          .
        </p>
      </main>
    </>
  );
}

export default PrivacyPolicy;
